import { render, staticRenderFns } from "./SpecificImport.vue?vue&type=template&id=39b03aad&scoped=true"
import script from "./SpecificImport.vue?vue&type=script&lang=js"
export * from "./SpecificImport.vue?vue&type=script&lang=js"
import style0 from "./SpecificImport.vue?vue&type=style&index=0&id=39b03aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b03aad",
  null
  
)

export default component.exports